import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Login from './Login';
import { AppBar, Toolbar, Typography, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { useUser } from '../contexts/UserContext';

const useStyles = makeStyles((theme) => ({
    title: {
        flexGrow: 1,
    },
    loginButton: {
        marginLeft: 'auto',
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    list: {
        width: 250,
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
}));

const Navbar = () => {
    const { user } = useUser();
    const classes = useStyles();
    const [drawerOpen, setDrawerOpen] = useState(false);

    const [utcTime, setUtcTime] = useState(new Date().toISOString());

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const formattedUtcTime = now.toISOString().slice(0, 19).replace('T', ' ') + ' UTC';
            setUtcTime(formattedUtcTime);
        }, 1000); // update every second
        return () => clearInterval(interval); // cleanup on unmount
    }, []);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const drawerItems = (
        <div className={classes.list} onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
            <List>
                {user.token && user.hasAnyRole(['jedimaster', 'engineer']) && (
                    <ListItem button component={Link} to="/plot" className={classes.link}>
                        <ListItemText primary="Plot" />
                    </ListItem>
                )}
                {user.token && user.hasAnyRole(['siemens-engineer', 'siemens-operator', 'jedimaster']) && (
                    <ListItem button component={Link} to="/sgre-forecast" className={classes.link}>
                        <ListItemText primary="SGRE Forecast" />
                    </ListItem>
                )}
                {/*<ListItem button component={Link} to="/about" className={classes.link}>
                    <ListItemText primary="About" />
                </ListItem>*/}
                {user.token && user.hasAnyRole(['jedimaster', 'engineer']) && (
                    <>
                        <ListItem button component={Link} to="/projects" className={classes.link}>
                            <ListItemText primary="Projects" />
                        </ListItem>
                        <ListItem button component={Link} to="/sites" className={classes.link}>
                            <ListItemText primary="Sites" />
                        </ListItem>
                        <ListItem button component={Link} to="/sources" className={classes.link}>
                            <ListItemText primary="Sources" />
                        </ListItem>
                    </>
                )}
                {user.token && user.hasRoles(['jedimaster']) && (
                    <>
                        <ListItem button component={Link} to="/users" className={classes.link}>
                            <ListItemText primary="Users" />
                        </ListItem>
                        <ListItem button component={Link} to="/dashboard" className={classes.link}>
                            <ListItemText primary="Dashboard" />
                        </ListItem>
                    </>
                )}
                {user.token && user.hasAnyRole(['jedimaster', 'heartbeats']) && (
                    <>
                        <ListItem button component={Link} to="/heartbeats" className={classes.link}>
                            <ListItemText primary="Heartbeats" />
                        </ListItem>
                    </>
                )}
            </List>
        </div>
    );

    return (
        <AppBar position="static">
            <Toolbar>
                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                    <MenuIcon />
                </IconButton>
                {user.token && user.hasAnyRole(['jedimaster', 'engineer']) && (
                    <Typography variant="h6" className={classes.title}>
                        <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
                    </Typography>
                )}
                <Typography variant="body2" className={classes.utcClock}>
                    {utcTime}
                </Typography>
                <div className={classes.loginButton}>
                    <Login />
                </div>
            </Toolbar>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                {drawerItems}
            </Drawer>
        </AppBar>
    );
};

export default Navbar;
